/* eslint-disable no-unused-vars */
export enum NAVIGATE_TYPE {
    NAVIGATE_TO = 'navigateTo',
    REDIRECT_TO = 'redirectTo',
    RE_LAUNCH = 'reLaunch',
    SWITCH_TAB = 'switchTab',
    NAVIGATE_BACK = 'navigateBack',
}

export const NAVIGATE_TYPE_LIST = ['navigateTo', 'redirectTo', 'reLaunch', 'switchTab']

export const HOME_PAGE = '/pages/home/index'
export const LOGIN_PAGE = '/pages/login/index'
export const NOT_FOUND_PAGE = '/pages/error/404'
